import React from 'react'
function Error () {
return (  
<div className='container'>
    <div className='card mt-3 mx-5' style={{width:'65rem'}}>
        <img src='https://wallpapercave.com/dwp1x/wp2414725.jpg' className='img-fluid' />
    </div>
</div>
)
}
export default Error